/* eslint-disable no-unused-vars */
!(function (e) {
	function t(o) {
		if (n[o]) return n[o].exports;
		var r = (n[o] = { i: o, l: !1, exports: {} });
		return e[o].call(r.exports, r, r.exports, t), (r.l = !0), r.exports;
	}
	var n = {};
	(t.m = e),
		(t.c = n),
		(t.d = function (e, n, o) {
			t.o(e, n) || Object.defineProperty(e, n, { configurable: !1, enumerable: !0, get: o });
		}),
		(t.n = function (e) {
			var n =
				e && e.__esModule
					? function () {
							return e.default;
						}
					: function () {
							return e;
						};
			return t.d(n, 'a', n), n;
		}),
		(t.o = function (e, t) {
			return Object.prototype.hasOwnProperty.call(e, t);
		}),
		(t.p = '/dist/'),
		t((t.s = 0));
})([
	function (e, t, n) {
		e.exports = n(1);
	},
	function (e, t, n) {
		'use strict';
		function o(e, t) {
			if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
		}
		Object.defineProperty(t, '__esModule', { value: !0 });
		var r = (function () {
				function e(e, t) {
					for (var n = 0; n < t.length; n++) {
						var o = t[n];
						(o.enumerable = o.enumerable || !1),
							(o.configurable = !0),
							'value' in o && (o.writable = !0),
							Object.defineProperty(e, o.key, o);
					}
				}
				return function (t, n, o) {
					return n && e(t.prototype, n), o && e(t, o), t;
				};
			})(),
			i = (function () {
				function e(t) {
					o(this, e), (this.config = t);
				}
				return (
					r(
						e,
						[
							{
								key: 'track',
								value: function (t) {
									var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
									(t.url = e._getUri()), (this.config.tags = this.config.tags || []);
									var o = this._cleanCombineTwoArrays(t.tags, this.config.tags);
									if (((t = Object.assign(t, this.config)), o.length > 0 && (t.tags = o), n))
										return this._sendRequest(e._getRequestOptions(t), n);
									this._sendRequest(e._getRequestOptions(t), n);
								}
							},
							{
								key: 'addConstantTag',
								value: function (e) {
									if ('string' == typeof e) {
										var t = !1;
										(this.config.tags = this.config.tags || []),
											this.config.tags.map(function (n) {
												n.toLowerCase() === e.toLowerCase() && (t = !0);
											}),
											t || this.config.tags.push(e);
									}
								}
							},
							{
								key: '_cleanCombineTwoArrays',
								value: function () {
									var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
										t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
										n = e.concat(t);
									return n.filter(function (e, t) {
										return n.indexOf(e) === t;
									});
								}
							},
							{
								key: '_sendRequest',
								value: function (e) {
									var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
									return new Promise(function (n, o) {
										var r = new XMLHttpRequest();
										t &&
											(r.onreadystatechange = function () {
												r.readyState === XMLHttpRequest.DONE &&
													(200 === r.status ? n(JSON.parse(r.responseText)) : o(JSON.parse(r.responseText)));
											}),
											r.open(e.method, e.url),
											r.setRequestHeader('Content-Type', 'application/json'),
											r.send(e.body);
									});
								}
							}
						],
						[
							{
								key: '_getUri',
								value: function () {
									return window.location.toString();
								}
							},
							{
								key: '_getRequestOptions',
								value: function (e) {
									return {
										url: 'https://sp-analytics.prtl.co/events',
										method: 'PUT',
										body: JSON.stringify(e)
									};
								}
							}
						]
					),
					e
				);
			})();
		(t.default = i), (window.SPTracker = i);
	}
]);
